var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapp"}},[_c('v-progress-linear',{staticClass:"ma-0",staticStyle:{"top":"-2px"},attrs:{"active":_vm.loading,"color":_vm.color,"background-opacity":"0","indeterminate":true,"height":"4","id":"main-loader"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }